import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@core/services/icons/icons.service';

import { FilterDataType, FilterOperation } from '../filter.models';

const TYPE_ICON_MAP: Record<FilterDataType, string> = {
  [FilterDataType.TEXT]: ICONS.textAa,
  [FilterDataType.MULTILINE_TEXT]: ICONS.textAlignLeft,
  [FilterDataType.UID]: ICONS.signature,
  [FilterDataType.UID_LIST]: ICONS.listBullets,
  [FilterDataType.LINK]: ICONS.link,
  [FilterDataType.NUMBER]: ICONS.binary,
  [FilterDataType.DATE]: ICONS.calendarBlank,
  [FilterDataType.SELECT]: ICONS.listBullets,
  [FilterDataType.MULTI_SELECT]: ICONS.listChecks,
  [FilterDataType.BOOLEAN]: ICONS.toggleRight,
  [FilterDataType.LABELS]: ICONS.tag,
  [FilterDataType.TAGS]: ICONS.tag,
  [FilterDataType.DURATION]: ICONS.clock
};

/** Operators that say everything on their own, so the chip shows no value segment. */
const VALUELESS_OPERATIONS: ReadonlySet<FilterOperation> = new Set([
  FilterOperation.IS_EMPTY,
  FilterOperation.IS_NOT_EMPTY,
  FilterOperation.IS_TRUE,
  FilterOperation.IS_FALSE
]);

@Component({
  selector: 'app-filter-pill',
  imports: [TranslatePipe],
  templateUrl: './filter-pill.component.html',
  styleUrl: './filter-pill.component.css'
})
export class FilterPillComponent {
  label = input.required<string>();
  type = input.required<FilterDataType>();
  operation = input.required<FilterOperation>();
  operationLabel = input<string>('');
  value = input<string>('');
  /** True while this pill's parameter dropdown is open. */
  active = input<boolean>(false);

  /** Opens the filter's parameter dropdown; editing never happens inline. */
  clickOnPill = output<void>();
  removeFilter = output<void>();

  protected readonly ICONS = ICONS;

  protected readonly typeIcon = computed(() => TYPE_ICON_MAP[this.type()]);

  protected readonly requiresValue = computed(
    () =>
      this.type() !== FilterDataType.BOOLEAN && !VALUELESS_OPERATIONS.has(this.operation())
  );
}
